import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import * as semesterAPI from "../../api/semester";
import { toast } from "react-toastify";

const initialState = {
  data: [],
  loading: null,
};

const addSemester = createAsyncThunk(
  "semester/add",
  async (params, { rejectWithValue }) => {
    try {
      const res = await semesterAPI.addSemester(params);
      if (res.data.statusCodeValue >= 400) {
        rejectWithValue(res.data.body.error);
        toast.error("Semester already exists");
      }
      else{
        toast.success("Semester added successfully");
        return res.data.body;
      }
    } catch (error) {
      rejectWithValue(error);
    }
  }
);

const getSemester = createAsyncThunk(
  "semester/get",
  async (params, { rejectWithValue }) => {
    try {
      const res = await semesterAPI.getSemester(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {
      rejectWithValue(error);
    }
  }
);

const semesterSlice = createSlice({
  name: "semester",
  initialState: initialState,
  reducers: {
    resetState: () => {
      return initialState;
    },
  },
  extraReducers: {
    [addSemester.pending]: (state) => {
      state.loading = true;
    },
    [addSemester.fulfilled]: (state, action) => {
      state.loading = false;
    },
    [addSemester.rejected]: (state) => {
      state.loading = false;
    },

    [getSemester.pending]: (state) => {
      state.loading = true;
    },
    [getSemester.fulfilled]: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    [getSemester.rejected]: (state) => {
      state.loading = false;
    },
  },
});

const { resetState } = semesterSlice.actions;

export default semesterSlice.reducer;

export { resetState, addSemester, getSemester };
